/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */

/**
 * The message's direction.
 */
export type Direction = (typeof Direction)[keyof typeof Direction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Direction = {
  INCOMING: "INCOMING",
  OUTGOING: "OUTGOING",
} as const;
